import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Divider, Switch } from 'antd';

/** 单行拖拽排序（@dnd-kit，替代 react-sortable-hoc，避免 findDOMNode 弃用警告） */
export default function QuickEntrySortableRow({ module, quickEntriesSwitchChange, showEditQuickEntriesDrawer, deleteQuickEntries }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: module.id,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.65 : undefined,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} className="main-table-tr main-quick-tr">
            <div className="main-table-title">
                <span dangerouslySetInnerHTML={{ __html: module.title }} />
            </div>
            <div className="main-table-blank">
                <span>{module.newBlankType === 2 ? '文件' : '链接'}</span>
            </div>

            <div className="main-table-switch">
                <Switch checked={!module.hidden} onChange={checked => quickEntriesSwitchChange(checked, module.id)} checkedChildren="显示" unCheckedChildren="隐藏" />
            </div>

            <div className="main-table-operations">
                <span className="operation-btns">
                    <Button size="small" type="link" onClick={() => showEditQuickEntriesDrawer(module)}>
                        编辑
                    </Button>
                    <Divider orientation="vertical" />
                    <Button size="small" type="link" onClick={() => deleteQuickEntries(module.id)}>
                        删除
                    </Button>
                </span>

                <Button type="text" size="small" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} aria-label="快捷入口排序" {...listeners}>
                    <i className="bi bi-grip-vertical"></i>
                </Button>
            </div>
        </div>
    );
}
